import { useEffect, useState } from "react";
import { getProjekte } from "../services/cdn.services";
import "./projekte.page.css";
import { ProjekteType } from "../types/projekte.type";
import { getCDNOrigin } from "../utils/envReader.util";
import LanguageButton from "../components/languageButton.component";
import React from "react";

function Projekte(
    props: Readonly<{
        isEnglish: boolean;
        setIsEnglish: (newValue: boolean) => void;
    }>
) {
    const { isEnglish, setIsEnglish } = props;

    //Fetch expertise data 
    useEffect(() => {
        const fetchData = async () => {
            setProjekteData(await getProjekte());
        };
        fetchData();
    }, [])
    const [projekteData, setProjekteData] = useState<ProjekteType[] | undefined>(undefined);

    const [showElements, setShowElements] = useState<number>(0);
    useEffect(() => {
        if (showElements === projekteData?.length) {
            return;
        }

        const timeout = setTimeout(() => {
            setShowElements(showElements + 1);
        }, 50);

        return () => clearTimeout(timeout);
    }, [showElements]);
    
    return (
        <div id="projekte" className="standard-page">
            <div className="flex column items-center">
                
                <div className="flex gap w-100 between items-center mt-5">
                    <div className="remove-on-phone" style={{width: 60}} />
                    <h5>{isEnglish ? "Projects" : "Projekte"}</h5>
                    <LanguageButton onToggle={() => setIsEnglish(!isEnglish)} isEnglish={isEnglish} />
                </div>
                <div className="projekte-container">
                    {
                        projekteData?.sort((a, b) => {
                            const dateA = a.bis ? a.bis : a.von;
                            const dateB = b.bis ? b.bis : b.von;

                            // Falls eines der Projekte kein Datum hat, schiebe es ans Ende
                            if (!dateA && !dateB) return 0; // Beide haben kein Datum -> gleiche Position
                            if (!dateA) return 1; // a hat kein Datum -> nach unten
                            if (!dateB) return -1; // b hat kein Datum -> nach unten

                            return dateB.localeCompare(dateA); // Sortiere absteigend (neueste zuerst)
                        })
                            .map((value: ProjekteType, index: number) => {

                                return <div className={`${showElements <= index ? "invisible-item" : "visible-item"} flex gap-4`} key={index}>
                                    <div className="flex column gap items-center">
                                        <div className="year-container">
                                            {
                                                value.von || value.bis ?
                                                <>
                                                    {value.von?.substring(0, 4) === value.bis?.substring(0, 4) ?
                                                        <p className="year">{value.bis?.substring(0, 4)}</p> :
                                                        <p className="year">{value.von && <>{value.von?.substring(0, 4)} {value.bis && value.von && "-"}<br /></>}{value.bis?.substring(0, 4)}</p>
                                                    }
                                                </> :
                                                <div className="round-dot" />
                                            }                                                                                    
                                        </div>
                                        {projekteData.length !== index + 1 && <div className="line" style={{ marginBottom: "var(--size-m)" }} />}
                                    </div>

                                    <div className={`flex column gap ${value.link ? "link-active" : ""}`} onClick={() => value.link ? (window.open(value.link, "_blank")) : ""}>
                                        {isEnglish ? 
                                            <h4 className="titel-main" style={!value.en_beschreibung ? { transform: "translateY(10px)" } : undefined}>{value.en_titel}</h4>
                                        :
                                            <h4 className="titel-main" style={!value.beschreibung ? { transform: "translateY(10px)" } : undefined}>{value.titel}</h4>
                                        }
                                        
                                        
                                        <div className="flex pb-4">
                                            <div className="flex column" style={{maxWidth: "100%"}}>
                                                {value?.video?.url &&
                                                    <video width="500" controls className="mb-2">
                                                        <source src={`${getCDNOrigin()}${value.video.url}`} type="video/mp4" />
                                                        Your browser does not support the video tag.
                                                    </video>
                                                }
                                                {value?.bild?.formats?.thumbnail?.url &&
                                                    <img src={`${getCDNOrigin()}${value.bild.formats.thumbnail.url}`} alt="projekt bild" width="200" />
                                                }

                                                <p className="beschreibung">
                                                    {(isEnglish ? value.en_beschreibung : value.beschreibung)
                                                        ?.split('\n')
                                                        .map((line, i) => (
                                                        <React.Fragment key={i}>
                                                            {line}
                                                            {i < (isEnglish ? value.en_beschreibung : value.beschreibung).split('\n').length - 1 && <br />}
                                                        </React.Fragment>
                                                    ))}
                                                </p>

                                            </div>

                                        </div>
                                    </div>
                                </div>
                            })
                    }
                </div>
            </div>
        </div>
    );
}

export default Projekte;